import { MotionConfig } from "framer-motion";
import EmptyItem from "../../comman/EmptyItem";
import { motion } from "framer-motion";

const List = ({ ...props }) => {
    const { data, onSelectTaskRequest } = props;
    const showCardImd = (item) => {
        const vidArr = ["mp4", "mp4", "mov", "wmv", "avi", "avchd", "flv", "f4v", "swf", "mkv", "webm", "html5"];
        const imgArr = ["jpg", "jpeg", "jfif", "pjpeg", "pjp", "png", "svg", "webp", "avif", "gif", "apng"];
        let ext = item.files[0].split('.').pop();
        let fext = ext.toLowerCase();
        const im = imgArr?.find((v) => v == fext);
        const vid = vidArr?.find((vi) => vi == fext);
        if (vid != undefined) {
            return (
                <video controls className="md:w-[118px] md:h-[68px] rounded-lg" src={item?.files[0]} alt="video not found" />
            )
        } if (im != undefined) {
            return (
                <img className="w-[118px] h-[68px] rounded-lg" src={item?.files[0]} alt="img not found" />
            )
        }
    }

    const getTextColor = (status) => {
        if (status === 'Reject') {
            return 'rejectText';
        }

        if (status === 'Cancelled')
            return 'cancelText';
        if (status === 'Accept')
            return 'acceptText';
        if (status === 'Link posted')
            return 'linkText';
        if (status === 'Approved')
            return 'approveText';
        if (status === 'Pending')
            return 'pendingText';

    }
    const getStatusName = (status) => {
        if (status === 'Reject')
            return 'Rejected';
        if (status === 'Cancelled')
            return 'Cancelled';
        if (status === 'Accept')
            return 'Accepted';
        if (status === 'Link posted')
            return 'Link posted';
        if (status === 'Approved')
            return 'Approved';
        if (status === 'Pending')
            return 'Pending';
    }

    const divAnimate2 = {
        offscreen: { y: 100, opacity: 0 },
        onscreen: {
            y:0,
            opacity: 1,
            transition: {
                type: "spring",
                bounce: 0,
                duration: 1
            }
        }

    };

    return (
        <>
            <div className="ms:container ms:mx-auto px-4 ms:px-2">
                <div className='' >
                    <>
                        {data?.length > 0 ? (
                            data?.map((item, i) => (
                                <motion.div variants={divAnimate2} transition={{ staggerChildren: 0.5 }} initial={"offscreen"} whileInView={"onscreen"} viewport={{ once: true, amount: 0.5 }} 
                                key={item?.id} onClick={() => { onSelectTaskRequest(item) }} className=" font-museo cursor-pointer p-2  my-2 rounded-lg "
                                    style={{ "boxShadow": "rgb(210 206 206 / 82%) 3px 5px 20px 1px" }} >
                                    <div className='flex md:flex-row flex-col  ' >
                                        <div>
                                            {
                                                showCardImd(item)
                                            }
                                        </div>
                                        <div className=' w-full flex lg:flex-row flex-col  justify-between md:mx-4 p-2 md:p-0 ' >
                                            <div >
                                                <h5 className="text-[#178ACB] text-lg font-extrabold  ">{item.campaign?.campaign_title}</h5>
                                                <p className="text-slate-500 font-museob ">{item?.created_at}</p>
                                                <div className="flex flex-wrap gap-2">
                                                    <p className="text-gray-500 font-museob " > <strong>Request By:</strong> {item?.influencer_name}</p>
                                                    {JSON.parse(item?.captions)?.map((caption, it) => (
                                                        <span key={it} className="bg-[#66BE9C] text-[11px] px-2 py-1 text-white font-museob rounded-full "> @{caption?.value}</span>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className=" md:max-w-[70%]" >
                                                <p className="text-xl" >Status : <span className={`${getTextColor(item?.status)} font-museobb`} >{getStatusName(item?.status)}</span> </p>
                                                {item?.status === 'Reject' && (
                                                    <div className=' p-2 font-museo '>
                                                        <p >
                                                            <span className="font-museob text-base " >Reason:</span> {item?.reject_reason}
                                                        </p>
                                                    </div>
                                                )}
                                                <div className="flex flex-wrap gap-2 py-2 " >
                                                    {item?.campaign?.allocatedBudget.map((item, i) => (
                                                        <span key={i} className="bg-[#3BB6E4] text-[11px] px-2 py-1 text-white font-museob rounded-full ">{item.soical_paltfom}</span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            ))
                        ) : (
                            <EmptyItem text="No Task found" />
                        )}
                    </>
                </div>

            </div>
        </>

    )
}

export default List;